import { useEffect } from 'react';

const KycIframe = ({ isOpen, signingUrl, onClose }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black bg-opacity-60"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className="relative bg-white rounded-lg w-[95%] h-[95%] max-w-7xl shadow-2xl">
        {/* Header */}
        <div className="flex justify-between items-center p-4 border-b border-gray-200 bg-gray-50 rounded-t-lg">
          <div>
            <h3 className="text-lg font-semibold text-gray-800">KYC Verification</h3>
            <p className="text-sm text-gray-600">Complete your Aadhaar verification</p>
          </div>
          <button 
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 text-3xl font-light leading-none p-2 hover:bg-gray-100 rounded-full transition-colors"
            title="Close"
          >
            ×
          </button>
        </div>
        
        {/* Iframe Container */}
        <div className="relative h-[calc(100%-80px)]">
          {signingUrl ? (
            <iframe 
              src={signingUrl}
              className="w-full h-full border-0 rounded-b-lg"
              title="KYC Verification Portal"
              allow="camera; microphone; geolocation"
              sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-top-navigation"
            />
          ) : (
            <div className="flex items-center justify-center h-full">
              <div className="text-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
                <p className="text-gray-600">Loading KYC verification...</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default KycIframe;